window.MediaRecorder = require('audio-recorder-polyfill');
